/**
 * Custom panel content placeholder component.
 * This file is overridden by jitsi-meet-branding at build time
 * to provide the actual panel content (e.g. iframe).
 *
 * @returns {null} This placeholder renders nothing.
 */
export default function CustomPanelContent() {
    return null;
}
